// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"896de02c","453":"93eb336c","732":"3b609c28","977":"9dca1b85"}[chunkId] + ".chunk.js";
};